export const CARDS_LIMIT_MSG =
  '0 will default to 3, use the No Active Accounts trigger'
